'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var ButtonJustify = _interopDefault(require('../button-justify'));
var SuspendMenu = _interopDefault(require('../suspend-menu'));
var Picker = _interopDefault(require('../picker'));

var monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var now = new Date();
var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('suspend-menu', {
      staticClass: "month-picker",
      attrs: {
        "show": _vm.show
      },
      on: {
        "clickMask": function clickMask($event) {
          _vm.$emit('hide');
        }
      }
    }, [_c('button-justify', {
      attrs: {
        "left": "取消",
        "right": "确认"
      },
      on: {
        "clickLeft": function clickLeft($event) {
          _vm.$emit('cancel');
        },
        "clickRight": _vm.onConfirm
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "month-picker-container"
    }, [_c('picker', {
      attrs: {
        "options": _vm.month
      },
      model: {
        value: _vm.selectedMonth,
        callback: function callback($$v) {
          _vm.selectedMonth = $$v;
        },
        expression: "selectedMonth"
      }
    }), _vm._v(" "), _c('picker', {
      attrs: {
        "options": _vm.year
      },
      model: {
        value: _vm.selectedYear,
        callback: function callback($$v) {
          _vm.selectedYear = $$v;
        },
        expression: "selectedYear"
      }
    })], 1)], 1);
  },
  staticRenderFns: [],
  name: 'month-picker',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    max: {
      type: Date,
      default: function _default() {
        return new Date(now.getFullYear() + 15, 11);
      }
    },
    min: {
      type: Date,
      default: function _default() {
        return now;
      }
    },
    format: {
      type: String,
      default: 'mm/yy'
    },
    startMonth: {
      type: Number,
      default: 0
    },
    startYear: {
      type: Number,
      default: 0
    }
  },
  components: {
    Picker: Picker,
    SuspendMenu: SuspendMenu,
    ButtonJustify: ButtonJustify
  },
  data: function data() {
    return {
      selectedYear: 0,
      selectedMonth: 0
    };
  },
  computed: {
    range: function range() {
      var min = this.min;
      var max = this.max;
      return {
        minYear: min.getFullYear(),
        maxYear: max.getFullYear(),
        minMonth: min.getMonth(),
        maxMonth: max.getMonth()
      };
    },
    month: function month() {
      var _this = this;

      var year = this.year[this.selectedYear].text;
      return monthList.map(function (month) {
        return {
          text: _this.pad(month),
          disabled: _this.isDisabled(year, month)
        };
      });
    },
    year: function year() {
      var year = [];

      for (var i = this.range.minYear; i <= this.range.maxYear; i++) {
        year.push({
          text: i
        });
      }

      return year;
    }
  },
  mounted: function mounted() {
    // 传数组index
    this.selectedYear = this.findIndex(this.year, this.startYear);
    this.selectedMonth = this.findIndex(this.month, this.startMonth);
  },
  methods: {
    pad: function pad(num) {
      return (num < 10 ? '0' : '') + num;
    },
    findIndex: function findIndex(arr, val) {
      var index = -1;

      for (var arrIndex = 0; arrIndex < arr.length; arrIndex++) {
        var element = arr[arrIndex];

        if (Number(element.text) === val) {
          index = arrIndex;
          break;
        }
      }

      return index === -1 ? 0 : index;
    },
    isDisabled: function isDisabled(year, month) {
      var range = this.range;
      return (year === range.minYear ? month < range.minMonth + 1 : false) || (year === range.maxYear ? month > range.maxMonth + 1 : false);
    },
    onConfirm: function onConfirm() {
      var year = this.year[this.selectedYear].text;
      var month = this.month[this.selectedMonth].text;
      var value = this.format.replace('yyyy', year).replace('yy', year - 2000 + '').replace('mm', month);
      this.$emit('confirm', value);
    }
  }
});

exports.default = index;
